export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center justify-center">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/bee767020a04c4939fe1302ceaf2addf.jpg)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      
      <div className="relative z-10 text-center px-4 sm:px-6 w-full max-w-5xl mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          Plombier Chauffagiste et Sanitaire
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-white/95 mb-3 sm:mb-4 font-medium">
          Ion Certan - Artisan à Valence
        </p>
        <p className="text-base sm:text-lg text-white/90 mb-6 sm:mb-8 max-w-3xl mx-auto px-2">
          Installation, entretien et dépannage de vos équipements de chauffage, climatisation et sanitaire
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4">
          <button
            onClick={scrollToContact}
            className="w-full sm:w-auto bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Demander un devis gratuit
          </button>
          <a
            href="tel:+33760705475"
            className="w-full sm:w-auto bg-white text-teal-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-center"
          >
            <i className="ri-phone-line mr-2"></i>
            07 60 70 54 75
          </a>
        </div>
        <div className="mt-8 sm:mt-12 flex items-center justify-center gap-2 text-white">
          <div className="flex">
            {[1, 2, 3, 4, 5].map((star) => (
              <i key={star} className="ri-star-fill text-yellow-400 text-base sm:text-lg"></i>
            ))}
          </div>
          <span className="text-sm sm:text-base font-medium">5,0 sur Google</span>
        </div>
      </div>
    </section>
  );
}
